<template lang="pug">
div
  .primary.py-6.py-sm-10
    v-container
      .d-flex.justify-center 
        img.main-footer-logo(:src="files + informations.img")
      nav.d-flex.flex-wrap.justify-center.main-footer-nav-menu.mt-6(v-if="!xs")
        v-btn.text-none.text-body-1(
          v-for="(route, i) in menu",
          :key="i",
          :to="route.path",
          color="white",
          active-class="secondary--text",
          text
        ) {{ route.name }}
      grid-container.justify-center.mt-6.mt-sm-8(
        cols="auto",
        cols-md="360px 360px",
        gap="32px"
      )
        div(v-for="({ title, items }, i) in contact", :key="'a' + i")
          .text-body-1.font-weight-bold.white--text.mb-3 {{ title }}
          a.d-flex.align-center.text-decoration-none(
            v-for="({ title, link, icon, target }, j) in items",
            :key="'b' + j",
            :href="link",
            :target="target"
          )
            v-btn.mb-2.mr-2(color="secondary", fab, depressed, x-small)
              i.primary--text.v-icon(:class="icon", style="font-size: 16px")
            span.text-body-2.white--text.world-break-all {{ title }}
  v-footer.white--text(color="accent")
    v-container.d-flex.flex-column.flex-sm-row.justify-space-around.align-center 
      span.text-center.py-2.text-caption.d-flex.flex-column.flex-sm-row.justify-center.mb-4.mb-sm-0
        span.mr-1 Todos os direitos reservados.
        span {{ informations.name }} © 2021.
      a(href="https://www.mrxweb.com.br/", target="_blank")
        img.logo-mrx(
          src="/img/mrx.svg",
          alt="MRX Web Sites",
          title="MRX Web Sites"
        )
</template>

<script>
import { getTelLinkFromPhone } from "../utils";
import { menu } from "../../config";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    branches() {
      return this.$rest("branches").list;
    },
    contact() {
      return this.branches.map((branche) => {
        const items = [];

        if (branche.local_link)
          items.push({
            title: branche.local_text,
            link: branche.local_link,
            icon: "fas fa-map-marker-alt",
            target: "_blank",
          });

        if (branche.tel)
          items.push({
            title: branche.tel,
            link: getTelLinkFromPhone(branche.tel || ""),
            icon: "fas fa-phone",
          });

        if (branche.email)
          items.push({
            title: branche.email,
            link: "mailto:" + branche.email,
            icon: "fas fa-envelope",
          });

        return {
          title: branche.title,
          items,
        };
      });
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style>
.main-footer-logo {
  width: 360px;
  max-width: 90vw;
}
.main-footer-nav-menu {
  gap: 24px;
}

.logo-mrx {
  height: 20px;
  filter: brightness(0) invert(1);
}
</style>
